export default __webpack_public_path__ + "static/media/418e7417-47f3-40a1-8817-519a566f9d82.a2cb9cab.eot";